<template>
  <aside class="legal-disclaimer">
    <p>
      <em>
        This article is general information only, not legal advice. Laws
        change and individual circumstances differ. For advice on your
        specific circumstances, consult a qualified legal practitioner. See
        our
        <NuxtLink :to="$localePath('/policies/terms')">Terms of Use</NuxtLink>
        for the full disclaimer.
      </em>
    </p>
  </aside>
</template>

<style scoped>
.legal-disclaimer {
  max-width: 42rem;
  margin: 3rem 0 1.5rem;
  padding: 0.9rem 0 1rem;
  border-top: 1px solid #e2e0d9;
  border-bottom: 1px solid #e2e0d9;
  color: #6b6b6b;
  font-size: 0.82rem;
  line-height: 1.6;
}

.legal-disclaimer p {
  margin: 0;
}

.legal-disclaimer em {
  font-style: italic;
}

.legal-disclaimer :deep(a) {
  color: #5a6ded;
  text-decoration: underline;
}
</style>
